import React, { useState, useEffect, useRef } from 'react';
import ErpTemplate from '../../../../components/ErpTemplate';
import { FaPen, FaPlus, FaSearch } from 'react-icons/fa';
import api from '../../../../services/api';
import { Link } from 'react-router-dom';
import '../../../../css/financeiro-parcela-pagar.css';

export default function PainelEventoParticipanteSituacao() {
    const token = localStorage.getItem('token');
    const [filtro, setFiltro] = useState([]);
    const [produtos, setEventoParticipanteSituacaos] = useState([]);
    const [buscando, setBuscando] = useState(false);

    const [selectedIds, setSelectedIds] = useState(new Set());
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(15);
    const controllerRef = useRef(null);

    const toggleSelect = (id) => setSelectedIds(prev => {
        const n = new Set(prev);
        n.has(id) ? n.delete(id) : n.add(id);
        return n;
    });
    const toggleAll = () => paginados.length > 0 && selectedIds.size === paginados.length
        ? setSelectedIds(new Set())
        : setSelectedIds(new Set(paginados.map(r => r.id)));

    const total = produtos.length;
    const totalPaginas = Math.max(1, Math.ceil(total / pageSize));
    const paginados = produtos.slice((page - 1) * pageSize, page * pageSize);

    const buscar = () => {
        if (controllerRef.current) controllerRef.current.abort();
        controllerRef.current = new AbortController();
        setBuscando(true);
        api({
            method: 'get',
            action: '/eventoParticipanteSituacao',
            token: token,
            params: filtro,
            signal: controllerRef.current.signal
        })
            .then(response => {
                setEventoParticipanteSituacaos(response.data.data);
                setBuscando(false);
            }).catch(err => {
                if (err.code === "ERR_CANCELED" || err.name === "CanceledError") return;
                //console.log(err)
                setBuscando(false);
            });
    };

    useEffect(() => { //onload
        document.querySelector("#nome").focus(); //autofocus no nome
        buscar();
        return () => { if (controllerRef.current) controllerRef.current.abort(); };
    },
    // eslint-disable-next-line
    []);

    return (
        <ErpTemplate>
            <div className="main-content container-fluid fin-pp">
                <div className="fin-pp__head">
                    <div>
                        <h1 className="fin-pp__title">Status de Participante</h1>
                    </div>
                    <div className="fin-pp__actions">
                        <Link to="/cadastroEventoParticipanteSituacao" className="fin-pp__btn fin-pp__btn--primary fin-pp__btn--pill">
                            <FaPlus size={14} /> Novo Status
                        </Link>
                    </div>
                </div>

                <form className="fin-pp__card fin-pp__search" style={{ marginBottom: 16, padding: '12px 16px' }}
                    onSubmit={(e) => { buscar(); e.preventDefault(); }}>
                    <div className="fin-pp__search-field">
                        <FaSearch className="fin-pp__search-ic" size={16} />
                        <input
                            className="fin-pp__input"
                            type="text"
                            id="nome"
                            placeholder="Buscar pelo nome do status"
                            onChange={e => setFiltro({ ...filtro, ...{ "nome": e.target.value } })}
                        />
                    </div>
                    <button type="submit" className="fin-pp__btn fin-pp__btn--primary" disabled={buscando}>
                        {buscando ? 'Buscando...' : 'Buscar'}
                    </button>
                </form>

                <div className="fin-pp__card" style={{ overflow: 'hidden' }}>
                    <div className="fin-pp__tblwrap">
                        <table className="fin-pp__tbl" style={{ tableLayout: 'auto' }}>
                            <thead>
                                <tr>
                                    <th style={{ width: 40 }}>
                                        <input type="checkbox"
                                            checked={paginados.length > 0 && selectedIds.size === paginados.length}
                                            onChange={toggleAll}
                                        />
                                    </th>
                                    <th style={{ width: 60 }}></th>
                                    <th style={{ width: 110 }}>Situação</th>
                                    <th style={{ width: 100 }}>Código</th>
                                    <th>Nome</th>
                                </tr>
                            </thead>
                            <tbody>
                                {buscando
                                    ? <tr><td colSpan={5} className="fin-pp__empty"><span className="fin-pp__loading"><span className="fin-pp__spin"></span>Buscando...</span></td></tr>
                                    : paginados.length === 0
                                        ? <tr><td colSpan={5} className="fin-pp__empty">Nenhum registro</td></tr>
                                        : paginados.map(row => (
                                            <tr key={row.id}>
                                                <td>
                                                    <input type="checkbox"
                                                        checked={selectedIds.has(row.id)}
                                                        onChange={() => toggleSelect(row.id)}
                                                    />
                                                </td>
                                                <td>
                                                    {row.bancoDados && (
                                                        <Link to={"/cadastroEventoParticipanteSituacao/" + row.id} className="fin-pp__rowbtn">
                                                            <FaPen size={14} />
                                                        </Link>
                                                    )}
                                                </td>
                                                <td>
                                                    <span className={`fin-pp__pill ${row.situacaoRegistro === 'ativo' ? 'is-ok' : 'is-muted'}`}>
                                                        {row.situacaoRegistro}
                                                    </span>
                                                </td>
                                                <td style={{ textAlign: 'right' }}>{row.codigo ?? ''}</td>
                                                <td className="fin-pp__cell-strong">{row.nome ?? ''}</td>
                                            </tr>
                                        ))
                                }
                            </tbody>
                        </table>
                    </div>
                    <div className="fin-pp__pagination">
                        <div className="fin-pp__pagination-info">{total} registros</div>
                        <div className="fin-pp__pagination-ctrls">
                            <select className="fin-pp__select" style={{ height: 34 }} value={pageSize}
                                onChange={e => { setPageSize(Number(e.target.value)); setPage(1); }}>
                                <option value={15}>15 / pág</option>
                                <option value={30}>30 / pág</option>
                                <option value={50}>50 / pág</option>
                            </select>
                            <button className="fin-pp__btn fin-pp__btn--sm" disabled={page <= 1} onClick={() => setPage(p => p - 1)}>Anterior</button>
                            <span className="fin-pp__pagination-info">{page} / {totalPaginas}</span>
                            <button className="fin-pp__btn fin-pp__btn--sm" disabled={page >= totalPaginas} onClick={() => setPage(p => p + 1)}>Próxima</button>
                        </div>
                    </div>
                </div>
            </div>
        </ErpTemplate>
    );
}
